let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("h0Ttl")).then(() => parcelRequire('ghn9b'));